// extracted by mini-css-extract-plugin
export default {"dashboard":"pageIntroduction_dashboard__R71v1","yourSatProgress":"pageIntroduction_yourSatProgress__+CzTl"};